export default "__VITE_ASSET__rYAeC9Zg__"